import { parseISO } from "date-fns";
import type { CostGranularity } from "./costSummary";

type Mode = "light" | "dark";

// Canvas cannot read CSS custom properties, so the categorical series colors
// are inlined per mode. Slot order is fixed (never cycled) and was validated
// for colorblind-safe separation between adjacent stacked segments.
const SERIES_COLORS: Record<Mode, string[]> = {
  light: ["#2a78d6", "#eb6834", "#1baf7a", "#eda100", "#e87ba4", "#008300", "#4a3aa7", "#e34948"],
  dark: ["#3987e5", "#d95926", "#199e70", "#c98500", "#d55181", "#008300", "#9085e9", "#e66767"],
};

// Past the eighth cost type there is no distinct hue left; the rest share a neutral.
const OVERFLOW_COLOR: Record<Mode, string> = { light: "#8a8985", dark: "#6b6a66" };

export const costTypeColor = (slot: number, mode: Mode) =>
  SERIES_COLORS[mode][slot] ?? OVERFLOW_COLOR[mode];

export const CHART_GRID_COLOR: Record<Mode, string> = { light: "#e0e0e0", dark: "#333333" };

export const CHART_AXIS_TEXT_COLOR: Record<Mode, string> = { light: "#767676", dark: "#bdbdbd" };

// "2026-10-05" -> "Oct 5, 2026" by day, "Week of Oct 5, 2026" by week, "Oct 2026" by month.
export const formatPeriod = (periodStart: string, granularity: CostGranularity) => {
  const start = parseISO(periodStart);
  if (granularity === "month") {
    return start.toLocaleDateString("en-US", { month: "short", year: "numeric" });
  }
  const day = start.toLocaleDateString("en-US", { dateStyle: "medium" });
  return granularity === "week" ? `Week of ${day}` : day;
};
